module.exports = __webpack_public_path__ + "img/google-app.0c2a6ab5.png";